import { render, staticRenderFns } from "./ArticleListView.vue?vue&type=template&id=254b4d19&scoped=true"
import script from "./ArticleListView.vue?vue&type=script&lang=js"
export * from "./ArticleListView.vue?vue&type=script&lang=js"
import style0 from "./ArticleListView.vue?vue&type=style&index=0&id=254b4d19&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "254b4d19",
  null
  
)

export default component.exports